import React from "react";
import ReactMarkdown from "react-markdown";
import "./Announcement.scss";
import {getTranslate, Translate, TranslateFunction} from "react-localize-redux";
import {Button, Modal} from "antd";
import {connect} from "react-redux";
import {AnnouncementData} from "../../interfaces/store/actions/payload/home";
import {DefaultAnnouncementIcon} from "../../assets/Icons";
import StoreState from "../../interfaces/store/storeState";
import {setFocusedElement} from "../../utils/common";

interface OwnProps {
    data: AnnouncementData
}

interface StateProps {
    translate: TranslateFunction
}

type Props = StateProps & OwnProps;

class Announcement extends React.Component<Props> {
    private static readonly translationPath: string = "components.Announcement.Announcement";

    constructor(props: Props) {
        super(props);

        this.onCloseHandler = this.onCloseHandler.bind(this);
        this.showFullAnnouncement = this.showFullAnnouncement.bind(this);
        this.onFocusChange = this.onFocusChange.bind(this);
    }

    /**
     * On focus change set current element as focused
     * @param {React.FocusEvent} e
     */
    onFocusChange(e: React.FocusEvent): void {
        const target: HTMLElement = e.target as HTMLElement;
        target.focus();
    }

    /**
     * Closing modal for full announcements and restoring focus on last 'learn more' button
     */
    onCloseHandler(): void {
        setFocusedElement();
    }

    /**
     * Show modal widow with full provided content
     */
    showFullAnnouncement(): void {
        const {info}: typeof Modal = Modal;
        const {data, translate}: Props = this.props;
        const {activeElement}: Document = document;
        if (activeElement) {
            activeElement.setAttribute("data-focus", "df-current");
        }

        info({
            className: "df-announcement-modal",
            title: data.Headline,
            content: <ReactMarkdown linkTarget="_blank">{data.Content}</ReactMarkdown>,
            centered: true,
            maskClosable: true,
            closable: true,
            okText: translate(`${Announcement.translationPath}.okBtnTxt.text`),
            width: 572,
            onOk: this.onCloseHandler,
            onCancel: this.onCloseHandler,
        });
    }

    render(): React.ReactElement {
        const {data}: Props = this.props;
        return (
            <div className="df-announcement-item">
                <div className="df-announcement-img-container">
                    {data.Picture ? <img src={data.Picture} alt=""/> : <DefaultAnnouncementIcon/>}
                </div>
                <div className="df-announcement-content">
                    <h3 className="df-announcement-headline">{data.Headline}</h3>
                    <span className="df-announcement-date">
                        {data.Date}
                    </span>
                    <ReactMarkdown linkTarget="_blank">{data.Introduction}</ReactMarkdown>
                    {data.Content && (
                        <Button
                            type="link"
                            className="df-announcement-more"
                            onClick={this.showFullAnnouncement}
                            onFocus={this.onFocusChange}
                        >
                            <Translate id={`${Announcement.translationPath}.learnMore.text`}/>
                        </Button>
                    )}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        translate: getTranslate(state.localize),
    };
}

export default connect(mapStateToProps)(Announcement);
